import { useEffect, useRef } from 'react'
import { isDevEnvironment } from '../utils/utils'

type UseDevWebViewPageVisibilityFallbackOptions = {
  onResume?: () => void
  enabled?: boolean
}

export function useDevWebViewPageVisibilityFallback(
  options: UseDevWebViewPageVisibilityFallbackOptions = {}
) {
  const { onResume, enabled = true } = options
  const onResumeRef = useRef(onResume)

  useEffect(() => {
    onResumeRef.current = onResume
  }, [onResume])

  useEffect(() => {
    if (!enabled || !isDevEnvironment() || typeof document === 'undefined') {
      return
    }

    let hasBeenHidden = false

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        hasBeenHidden = true
        return
      }
      if (hasBeenHidden) {
        onResumeRef.current?.()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [enabled])
}
